import staffApi from '@/apis/staff';

export const actions = {
  async getStaffs({ commit }, { active }) {
    const staffs = await staffApi.getStaffs({ active });

    commit('setStaff', staffs);
  },
};
